import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { AvailabilityCode } from "@app/models/rest/availability-code";

@Injectable({
  providedIn: "root"
})
export class AvailabilityCodeRestService extends HateoasResourceOperation<AvailabilityCode> {
  constructor() {
    super(AvailabilityCode);
  }
}
